import EmberObject from '@ember/object';
import config from 'mewe/config';
import CurrentUserStore from 'mewe/stores/current-user-store';
import * as Sentry from '@sentry/ember';
import { ds } from 'mewe/stores/ds';
import Service from '@ember/service';
import { getOwner } from '@ember/application';

// Create a globals service instead of using manual injection
class GlobalsService extends Service {
  apiHost = config.apiHost;
  currentUser = CurrentUserStore.getState();
  ds = ds;

  constructor() {
    super(...arguments);

    // Set up Sentry and update current user when available
    CurrentUserStore.getState().deferred.promise.then(() => {
      const user = CurrentUserStore.getState();
      this.currentUser = user;

      Sentry.configureScope((scope) => {
        scope.setUser({
          id: user.id,
        });
      });
    });
  }
}

export const initialize = (application) => {
  // Register the globals service
  application.register('service:globals', GlobalsService);
};

export default {
  name: 'globals',
  initialize,
};
